import script from "./RegionViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionViewer.vue?vue&type=script&setup=true&lang=js"

import "./RegionViewer.vue?vue&type=style&index=0&id=9be82368&lang=css"

const __exports__ = script;

export default __exports__